module.exports = __webpack_public_path__ + "img/start.2738c1fc.png";